import React from 'react';
import { HomePage } from './pages';
import AOS from 'aos';
import { useEffect } from 'react';
import 'aos/dist/aos.css';
import './App.css';


function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <React.Fragment>
      <HomePage />
    </React.Fragment>
  );
}

export default App;
